import * as angular from 'angular';

import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { HttpClient } from "@angular/common/http";

import { HttpService } from '../../../shared/ajs-bridges/http.service';
import { BasicDataSubService } from '../../../shared/basic-data-management/basic-data-subservice.class';
import { CachedDataSurveyService } from '../../../technical-modules/tasks/services/cached-data-survey.service';

import { ConstructeurTLR } from '../entities/constructeur.entity';

@Injectable({ providedIn: 'root' })
export class ConstructeurService {
	private path: string;
	private subService!: BasicDataSubService<ConstructeurTLR>;

	constructor( //
		@Inject(HttpClient) httpClient: HttpClient, //
		@Inject(HttpService) private httpService: HttpService, //
		@Inject(CachedDataSurveyService) cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: ConstructeurService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let serverDataChanged$ = cachedDataSurveyService.getChangeNotification("Constructeur");
		this.subService = new BasicDataSubService<ConstructeurTLR>(httpClient, this.path + 'constructeurs?format=TLR', serverDataChanged$);
	}
	
	/////////////////////////////////////////////////////////////////////////
	// Fonctions pour compatibilite avec les anciens composants Angular-JS
	/////////////////////////////////////////////////////////////////////////

	// Methode recuperant toutes les constructeurs.
	public getConstructeurs(): Promise<any> {
		let url = this.path + 'constructeurs/';
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant de recuperer une constructeur a partir de son identifiant.
	public getConstructeurById(id: number): Promise<any> {
		let url = this.path + 'constructeurs/' + id;
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant d'ajouter une constructeur.
	public create(data: any): Promise<any> {
		let url = this.path + 'constructeurs/';
		let result = this.httpService.post(url, data);
		return result;
	}

	// Methode permettant de modifier une constructeur.
	public update(id: number, data: any): Promise<any> {
		let url = this.path + 'constructeurs/' + id;
		let result = this.httpService.put(url, data);
		return result;
	}

	// Methode permettant de supprimer un constructeur.
	public deleteConstructeur(id: number): Promise<any> {
		let url = this.path + 'constructeurs/' + id;
		let result = this.httpService.delete(url);
		return result;
	}
	
	/////////////////////////////////////////////////////////////////////////
	// Fonctions pour les nouveaux composants Angular 12+
	/////////////////////////////////////////////////////////////////////////

	// Methode permettant le chargement de toutes les entites
	public getList = () => this.subService.getList();

	// Methodes permettant le chargement de tous les entities, selon differentes classifications et indexs
	// (NB: on procede a toutes les classifications en une fois, ce qui permet de n'iterer qu'une seule fois pour tous les resultats)
	public getMapById = () => this.subService.getMapById();
	public getById = (id: number) => this.subService.getKnownById(id, "ModeleOuvrageTLR");
}

angular
	.module('auroraApp')
	.service('constructeursService', downgradeInjectable(ConstructeurService));